import { PAY_RECHARGE, PAY_CONFIRM } from "../apis/payment";

export default {
  data() {
    return {
      query_timer: 0,
      query_pay_num: 0
    };
  },
  methods: {
    // 多货币支付方式
    onMulticurrencyPayment(Payment, callback) {
      this.MulticurrencyRecharge(Payment, callback);
    },
    /** 多货币充值方式
     * https://app.apifox.com/link/project/1121455/apis/api-265418758
     */
    async MulticurrencyRecharge(params, callback) {
      console.log("🚀 ~ Payment:", params);
      try {
        let rechargeType = "balance";
        if (this.payType === "PO") rechargeType = "pay";
        if (this.payType === "VIP") rechargeType = "vip";
        const query = {
          paymentId: this.pId,
          amount: this.price || "",
          rechargeType: rechargeType,
          userOpenId: this.user.p_openID,
          rentNow: rechargeType === "balance",
          qrCode: this.qrcode || this.$route.query.cabinetID || ""
        };
        if (this.payMode.includes("Toumkap")) {
          query.customerPhone = params.phone || "";
          query.customerEmail = params.email || "";
        }
        const headers = {
          headers: { "Content-Type": "application/json;charset=UTF-8" }
        };
        this.$loading(true);
        const Payment = this.selectPayment || { paymentMethodType: "" };
        const { data = {} } = await this.$Request(
          "POST",
          PAY_RECHARGE,
          query,
          headers
        );
        console.log("🚀 ~ data:", data, Payment, this.payMode);
        if (data.outTradeNo && Payment.pPaymentType.includes("Alipay")) {
          this.queryPaymentConfirm(data, callback);
          window.location.href = data.paymentInfo.payUrl;
          return false;
        } else if (data.outTradeNo && Payment.pPaymentType.includes("Wechat")) {
          this.wechatPayRequest(data.paymentInfo, res => {
            this.$loading(false);
            if (res) callback && callback(data);
          });
          return false;
        } else if (
          data.outTradeNo &&
          Payment.pPaymentType.includes("Toumkap")
        ) {
          // await this.MulticurrencyConfirm(data.outTradeNo, data.tradeNo)
          //   .then(result => callback(result))
          //   .catch(res => callback(res));
          // return false;
          return this.queryPaymentConfirm(data, callback);
        }
        throw new Error(data.message);
      } catch (error) {
        this.$loading(false);
        this.$toast(error);
        throw new Error(error);
      }
    },
    // 多货币确认支付方式
    async MulticurrencyConfirm(outTradeNo, tradeNo) {
      const query = { outTradeNo: outTradeNo || "", tradeNo: tradeNo || "" };
      const { data = {} } = await this.$Request("GET", PAY_CONFIRM, query);
      return data;
    },
    // 查询支付确认
    async queryPaymentConfirm(Payment, callback) {
      if (this.query_pay_num > 12) {
        clearTimeout(this.query_timer);
        this.query_pay_num = 0;
        const res = { ...Payment, error: 1, message: "Payment failed" };
        callback && callback(res);
        return false;
      }
      const callbackCell = result => {
        const orderStatus = (result && result.orderStatus) || "";
        if (parseInt(orderStatus) === 1) {
          this.$loading(false);
          callback && callback(Payment);
        } else {
          this.query_pay_num++;
          this.query_timer = setTimeout(() => {
            this.queryPaymentConfirm(Payment, callback);
          }, 2200);
        }
      };
      if (Payment.outTradeNo) {
        await this.MulticurrencyConfirm(Payment.outTradeNo, Payment.tradeNo)
          .then(result => {
            callbackCell(result);
          })
          .catch(res => {
            callbackCell(res);
          });
      }
    }
  }
};
